<div id="fab-dismiss" *ngIf="fabTogglerState === 'active'" (click)="onToggleFab()"></div>
<div class="fab-container">
  <button mat-fab class="fab-toggler" (click)="onToggleFab()">
    <i style="color: black" class="material-icons" [@fabToggler]="{ value: fabTogglerState }"
      >add</i
    >
  </button>
  <div [@speedDialStagger]="buttons.length">
    <button
      *ngFor="let btn of buttons"
      [matTooltip]="btn.label"
      [disabled]="btn.disabled"
      (click)="btn.click()"
      mat-mini-fab
      class="fabButton"
      matTooltipPosition="left"
    >
      <sn-icon *ngIf="btn.icon; else faIconTmpl">{{ btn.icon }}</sn-icon>
      <ng-template #faIconTmpl>
        <sn-icon
          [style.color]="iconColor"
          [fontSet]="btn.fontSet"
          [fontIcon]="btn.fontIcon"
        ></sn-icon>
      </ng-template>
    </button>
  </div>
</div>
